import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { AdminUsersService } from '../../admin-users/services/admin-users.service';
import { AuthDataStorageService } from '../services/auth-data-storage.service';

@Injectable()
export class ExternalSessionGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService, private authDataStorageService: AuthDataStorageService, private adminUsersService: AdminUsersService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const sessionId = route.queryParams['sessionId'];

    if (sessionId) {
      localStorage.setItem('token', JSON.stringify({ sessionId }));
      this.router.navigate([], { queryParams: { sessionId: null }, queryParamsHandling: 'merge' });
      return false;
    }

    return true;
  }
}




// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/auth/guard/external-session.guard.ts